import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
//import ReactDOM from 'react-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/styles';
//import PropTypes from 'prop-types';
import TimeField from 'react-simple-timefield';
//import Chip from '@material-ui/core/Chip';
//import Autocomplete from '@material-ui/lab/Autocomplete';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import axios from 'axios';

import { 
  Button, 
  Dialog, 
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // ListItemText, 
  Box,
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  // Paper,
  Tabs,
  Tab,
  // GridList,
  // GridListTile,
  // GridListTileBar,
  // ListSubheader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  // TablePagination,
  Checkbox,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
//import InfoIcon from '@material-ui/icons/Info';

import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { SelectAreaGroup } from 'components';

import { deviceVolumes } from 'common/datas';
import { IsNoU, adCheckStatus } from 'common/utils';

import { StatusAdvertise, StatusBullet } from 'components';

// >> redux
import {
  getCampaignAdvertises,
} from '../../../../redux/actions/campaigns';
import { Edit } from '@material-ui/icons';
// <<


const defaultColor = '#eee';
const normalColor = 'yellow';
const freeColor = 'pink';
const imageColor = 'peru';
const topColor = '#B19CD9';


const selectDeviceVolumes = [{ 
  value: '-1',
  label: '없음',
}, ...deviceVolumes];

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 6;

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  display: 'flex',
  padding: grid,
  overflow: 'auto',
  width: '1024px',
  height: '62px',
});


const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  margin: `0 ${grid}px 0 0`,
  height: '40px',
  display: 'flex',
  background: isDragging ? 'lightgreen' : 'white',

  ...draggableStyle,
});

//const getTexttyle = (bg_color, play_time) => ({
const getTexttyle = (bg_color, text_length) => ({
  // some basic styles to make the items look a bit nicer
  padding: grid,
  //width: play_time*4,
  width: text_length*14,
  height: 28,
  backgroundColor: bg_color,
});

const getImageTexttyle = (bg_color, text_length) => ({
  // some basic styles to make the items look a bit nicer
  padding: grid,
  width: text_length*10*2,
  height: 28,
  backgroundColor: bg_color,
});

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row_valued_advertise: {
    width: '320px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
    '& > *': {
      marginLeft: theme.spacing(0),
      margin: theme.spacing(1),
    },
  },
  row_type_advertise: {
    width: '480px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
    '& > *': {
      marginLeft: theme.spacing(0),
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  sub_header_title: {
    marginLeft: theme.spacing(2),
    width: 180,
  },
  registerListItemTitle: {
    //marginLeft: theme.spacing(2),
    width: 180,
  },
  registerListItemSubTitle: {
    //marginLeft: theme.spacing(2),
    width: 120,
  },
  // registerListTimeTitle: {
  //   // marginLeft: theme.spacing(4),
  //   // marginRight: theme.spacing(2),
  //   width: '150px',
  //   // display: 'flex',
  //   // flexDirection: 'column',
  //   // alignItems: 'center',
  //   // justifyContent: 'center',
  // },
  // advertiseDefaultsTitle: {
  //   marginLeft: theme.spacing(2),
  //   width: '100px',
  //   //height: '42px',
  // },
  registerListItemVolume: {
    //marginLeft: theme.spacing(2),
    width: '120px',
    //height: '40px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },
}));

const styleTabPanel = ({
  margin: '10px',
});



/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RegisterCampaign = props => {

  const {
    openDialog,
    modeReserveDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    editCampaign,
    advertises,

    areas,
    groups,
  } = props;

  const classes = useStyles();

  const [campaignAdvertises, setCampaignAdvertises] = useState([]);

  const [campaignName, setCampaignName] = useState('');
  const [disabledCampaignName, setDisabledCampaignName] = useState(false);
  const [lcdOffStartTime, setlcdOffStartTime] = useState('00:00');
  const [lcdOffEndTime, setlcdOffEndTime] = useState('00:00');

  const [deviceVolume, setDeviceVolume] = useState(3);
  const [deviceTimeVolume, setDeviceTimeVolume] = useState(-1);
  const [timeVolumeStartTime, setTimeVolumeStartTime] = useState('00:00');
  const [timeVolumeEndTime, setTimeVolumeEndTime] = useState('00:00');

  const [deviceBright, setDeviceBright] = useState(3);
  const [deviceTimeBright, setDeviceTimeBright] = useState(-1);
  const [timeBrightnessStartTime, setTimeBrightnessStartTime] = useState('00:00');
  const [timeBrightnessEndTime, setTimeBrightnessEndTime] = useState('00:00');

  const [selectedArea, setSelectedArea] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState(new Date());

  const [tabIndex, setTabIndex] = useState(0);

  const [defaults, setDefaults] = useState([]);
  const [normals, setNormals] = useState([]);
  const [images, setImages] = useState([]);

  const [adDefaults, setAdDefaults] = useState([]);
  const [adNormals, setAdNormals] = useState([]);
  const [adFrees, setAdFrees] = useState([]);
  const [adImages, setAdImages] = useState([]);
  const [adTops, setAdTops] = useState([]);

  const [openInsertDialog, setOpenInsertDialog] = useState(false);

  const onTimeChange = name => (event, value) => {
    const newTime = value.replace(/-/g, ':');
    const time = newTime.substr(0, 5);
    // const timeSeconds = newTime.padEnd(8, this.state.timeSeconds.substr(5, 3));
    // const timeSecondsCustomColon = timeSeconds.replace(/:/g, '-');

    ///setState({time, timeSeconds, timeSecondsCustomColon});
    //setState({ ...state, [name]: time });
    if (name === 'startTime') {
      setlcdOffStartTime(time);
    }
    else if (name === 'endTime') {
      setlcdOffEndTime(time);
    }
    else if (name === 'timeVolumeStartTime') {
      setTimeVolumeStartTime(time);
    }
    else if (name === 'timeVolumeEndTime') {
      setTimeVolumeEndTime(time);
    }
    else if (name === 'timeBrightnessStartTime') {
      setTimeBrightnessStartTime(time);
    }
    else if (name === 'timeBrightnessEndTime') {
      setTimeBrightnessEndTime(time);
    }
    else if (name === 'selectedTime') {
      setSelectedTime(time);
    }
  }

  const [areaGroups, setAreaGroups] = useState([]);

  const handleChangeArea = (e) => {
    let newAreaGroups = groups.filter(group => group.area === e.target.value);
    //console.log('new groups ->');
    //console.log(newAreaGroups);
    setAreaGroups(newAreaGroups);
    setSelectedGroup('');
    setSelectedArea(e.target.value)
  }

  const handleChangeTabs = (event, newValue) => {
    setTabIndex(newValue);
  };

  const onDragEnd = (result) => {

    //console.log(result);

    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      let datas = [];
      if (source.droppableId === 'droppableDefault') {
        datas = defaults;
      }
      else if (source.droppableId === 'droppableNormal') {
        datas = normals;
      }
      else if (source.droppableId === 'droppableImage') {
        datas = images;
      }

      else if (source.droppableId === 'droppableAdDefault') {
        datas = adDefaults;
      }
      else if (source.droppableId === 'droppableAdNormal') {
        datas = adNormals;
      }
      else if (source.droppableId === 'droppableAdFree') {
        datas = adFrees;
      }
      else if (source.droppableId === 'droppableAdImage') {
        datas = adImages;
      }
      else if (source.droppableId === 'droppableAdTop') {
        datas = adTops;
      }

      const items = reorder(
          datas,
          source.index,
          destination.index
      );

      if (source.droppableId === 'droppableDefault') {
        const ads = items;
        //console.log(ads);
        ads.sort( (ad_a, ad_b) => {
          return ad_a.template === 'top' && ad_b.template === 'default' ? -1 : 
            ad_a.template === 'default' && ad_b.template === 'top' ? 1 : 0;
        });
        setDefaults(ads);
      }
      else if (source.droppableId === 'droppableNormal') {
        setNormals(items);
      }
      else if (source.droppableId === 'droppableImage') {
        setImages(items);
      }

      else if (source.droppableId === 'droppableAdDefault') {
        setAdDefaults(items);
      }
      else if (source.droppableId === 'droppableAdNormal') {
        setAdNormals(items);
      }
      else if (source.droppableId === 'droppableAdFree') {
        setAdFrees(items);
      }
      else if (source.droppableId === 'droppableAdImage') {
        setAdImages(items);
      }
      else if (source.droppableId === 'droppableAdTop') {
        setAdTops(items);
      }

    } else {

      if (tabIndex === 0) {
        if ((source.droppableId === 'droppableAdDefault' && 
            destination.droppableId === 'droppableDefault') ||
          (source.droppableId === 'droppableDefault' && 
            destination.droppableId === 'droppableAdDefault')){
        }
        else {
          return ;
        }
      }
      else if (tabIndex === 1 || tabIndex === 2) {
        if (((source.droppableId === 'droppableAdNormal' && 
            destination.droppableId === 'droppableNormal') ||
          (source.droppableId === 'droppableNormal' && 
            destination.droppableId === 'droppableAdNormal')) ||
            ((source.droppableId === 'droppableAdFree' && 
            destination.droppableId === 'droppableNormal') ||
          (source.droppableId === 'droppableNormal' && 
            destination.droppableId === 'droppableAdFree'))){
        }
        else {
          return ;
        }
      }
      else if (tabIndex === 3) {
        if ((source.droppableId === 'droppableAdImage' && 
            destination.droppableId === 'droppableImage') ||
          (source.droppableId === 'droppableImage' && 
            destination.droppableId === 'droppableAdImage')){
        }
        else {
          return ;
        }
      }
      else if (tabIndex === 4) {
        if ((source.droppableId === 'droppableAdTop' && 
            destination.droppableId === 'droppableDefault') ||
          (source.droppableId === 'droppableDefault' && 
            destination.droppableId === 'droppableAdTop')){
        }
        else {
          return ;
        }
      }
      else {
        if (source.droppableId === 'droppableDefault' ||
           destination.droppableId === 'droppableDefault') {
            return ;
        }
        else {
        }
      }

      let sources = [];
      let destinations = [];
      if (source.droppableId === 'droppableDefault') {
        sources = defaults;
      }
      else if (source.droppableId === 'droppableNormal') {
        sources = normals;
      }
      else if (source.droppableId === 'droppableImage') {
        sources = images;
      }
      else if (source.droppableId === 'droppableAdDefault') {
        sources = adDefaults;
      }
      else if (source.droppableId === 'droppableAdNormal') {
        sources = adNormals;
      }
      else if (source.droppableId === 'droppableAdFree') {
        sources = adFrees;
      }
      else if (source.droppableId === 'droppableAdImage') {
        sources = adImages;
      }
      else if (source.droppableId === 'droppableAdTop') {
        sources = adTops;
      }

      if (destination.droppableId === 'droppableDefault') {
        destinations = defaults;
      }
      else if (destination.droppableId === 'droppableNormal') {
        destinations = normals;
      }
      else if (destination.droppableId === 'droppableImage') {
        destinations = images;
      }
      else if (destination.droppableId === 'droppableAdDefault') {
        destinations = adDefaults;
      }
      else if (destination.droppableId === 'droppableAdNormal') {
        destinations = adNormals;
      }
      else if (destination.droppableId === 'droppableAdFree') {
        destinations = adFrees;
      }
      else if (destination.droppableId === 'droppableAdImage') {
        destinations = adImages;
      }
      else if (destination.droppableId === 'droppableAdTop') {
        destinations = adTops;
      }

      if (destination.droppableId === 'droppableImage' && destinations.length >= 1)
        return ;
      
      const movedResult = move(
          sources,
          destinations,
          source,
          destination
      );

      //console.log(movedResult);

      if (source.droppableId === 'droppableDefault') {
        setDefaults(movedResult.droppableDefault);
      }
      else if (source.droppableId === 'droppableNormal') {
        setNormals(movedResult.droppableNormal);
      }
      else if (source.droppableId === 'droppableImage') {
        setImages(movedResult.droppableImage);
      }

      else if (source.droppableId === 'droppableAdDefault') {
        setAdDefaults(movedResult.droppableAdDefault);
      }
      else if (source.droppableId === 'droppableAdNormal') {
        setAdNormals(movedResult.droppableAdNormal);
      }
      else if (source.droppableId === 'droppableAdFree') {
        setAdFrees(movedResult.droppableAdFree);
      }
      else if (source.droppableId === 'droppableAdImage') {
        setAdImages(movedResult.droppableAdImage);
      }
      else if (source.droppableId === 'droppableAdTop') {
        setAdTops(movedResult.droppableAdTop);
      }

      if (destination.droppableId === 'droppableDefault') {
        const ads = movedResult.droppableDefault;
        //console.log(ads);
        //if (ad.template === 'top') 
        {
          ads.sort( (ad_a, ad_b) => {
            return ad_a.template === 'top' && ad_b.template === 'default' ? -1 : 
              ad_a.template === 'default' && ad_b.template === 'top' ? 1 : 0;
          });
          //const newDefaults = defaults.slice(0);
          // let default_ads = ads.filter(default_ad => {
          //   return (default_ad.template === 'default');
          // });
          // let top_ads = ads.filter(top_ad => {
          //   return (top_ad.template === 'top');
          // });
          // console.log(default_ads);
          // console.log(top_ads);
          //console.log(ads);
          setDefaults(movedResult.droppableDefault);
        }
        // else {
        //   setDefaults(movedResult.droppableDefault);
        // }
      }
      else if (destination.droppableId === 'droppableNormal') {
        setNormals(movedResult.droppableNormal);
      }
      else if (destination.droppableId === 'droppableImage') {
        setImages(movedResult.droppableImage);
      }
      else if (destination.droppableId === 'droppableAdDefault') {
        setAdDefaults(movedResult.droppableAdDefault);
      }
      else if (destination.droppableId === 'droppableAdNormal') {
        setAdNormals(movedResult.droppableAdNormal);
      }
      else if (destination.droppableId === 'droppableAdFree') {
        setAdFrees(movedResult.droppableAdFree);
      }
      else if (destination.droppableId === 'droppableAdImage') {
        setAdImages(movedResult.droppableAdImage);
      }
      else if (destination.droppableId === 'droppableAdTop') {
        setAdTops(movedResult.droppableAdTop);
      }
    }
  }


  const onClickOpenInsertDialog = () => {

    let template = 'default';
    if (tabIndex === 0) {
      template = 'default';
    }
    else if (tabIndex === 1) {
      template = 'normal';
    }
    else if (tabIndex === 2) {
      template = 'free';
    }
    else if (tabIndex === 3) {
      template = 'image';
    }
    else if (tabIndex === 4) {
      template = 'top';
    }
    //console.log(template);
    setCampaignAdvertises([]);
    props.getCampaignAdvertises(template);

    setOpenInsertDialog(true);
  }

  const onClickCloseInsertDialog = () => {
    setOpenInsertDialog(false);
  }

  const [selectedAdvertises, setSelectedAdvertises] = useState([]);

  const handleSelectAll = event => {

    let newSelectedAdvertises;

    if (event.target.checked) {
      newSelectedAdvertises = campaignAdvertises.map(advertise => advertise.id);
    } else {
      newSelectedAdvertises = [];
    }

    //console.log(selectedAdvertises);

    setSelectedAdvertises(newSelectedAdvertises);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedAdvertises.indexOf(id);
    let newSelectedAdvertises = [];

    if (selectedIndex === -1) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises, id);
    } else if (selectedIndex === 0) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises.slice(1));
    } else if (selectedIndex === selectedAdvertises.length - 1) {
      newSelectedAdvertises = newSelectedAdvertises.concat(selectedAdvertises.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedAdvertises = newSelectedAdvertises.concat(
        selectedAdvertises.slice(0, selectedIndex),
        selectedAdvertises.slice(selectedIndex + 1)
      );
    }

    //console.log(newSelectedAdvertises);

    setSelectedAdvertises(newSelectedAdvertises);
  };

  const [openProgress, setOpenProgress] = useState(false);

  const getCheckedCampaignInfo = (name) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/campaign/check`,
      data: {
        name
      }
    });
  }

  const handleSaveCampaign = () => {
    const defaultAds = defaults.map(advertise => advertise.id);;
    const normalAds = normals.map(advertise => advertise.id);;
    const imageAds = images.map(advertise => advertise.id);;

    let reserved_at = null;
    if (modeReserveDialog) {
      reserved_at = moment(selectedDate).format('YYYY-MM-DD') + " " + selectedTime;
      //console.log('reserved_at -> ');
      //console.log(reserved_at);
      //console.log(editCampaign);
    }

    const newCampaign = {
      name: campaignName,
      lcd_off_start_time: lcdOffStartTime,
      lcd_off_end_time: lcdOffEndTime,
      volume: deviceVolume,
      time_volume: deviceTimeVolume,
      time_volume_start: timeVolumeStartTime,
      time_volume_end: timeVolumeEndTime,
      brightness: deviceBright,
      time_brightness: deviceTimeBright,
      time_brightness_start: timeBrightnessStartTime,
      time_brightness_end: timeBrightnessEndTime,
      area: selectedArea,
      group: selectedGroup,
      defaults: defaultAds,
      normals: normalAds,
      images: imageAds,
      deployed_at: (modeReserveDialog ? null : new Date()),
      reserved_at: (modeReserveDialog ? reserved_at : null),
    };

    if (!IsNoU(editCampaign))
      newCampaign.id = editCampaign.id;

    onClickSaveDialog(newCampaign);
  }

  const handleCheckCampaign = async (name) => {
    const res = await getCheckedCampaignInfo(name);
    //console.log(res);
    const resultCheck = res.data.checked;
    //console.log(resultCheck);
    //setDisabledEditUserId(checkeduserid);
    setOpenProgress(false);
    if (resultCheck === 0) {
      handleSaveCampaign();
    }
    else if (resultCheck === 1) {
      toast(campaignName+"이/가 존재 합니다.");
    }
    // else if (resultCheck === 2) {
    //   toast(categorySavePath+"이/가 존재 합니다.");
    // }
  }

  const getItemText = (item) => {
    let ret_string = '';
    if (!IsNoU(item.name))
      ret_string += item.name;
    if (!IsNoU(item.playtime))
      ret_string += ' ('+Math.floor(item.playtime/60)+'분'+Math.floor(item.playtime%60) + '초)';

    return ret_string;
  }

  useEffect(() => {
    //console.log("componentDidMount");

    //setAdDefaults(props.advertises);
    let newCampaignAdvertises = [...advertises];
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      if (adCheckStatus(obj) === 'danger') {
        return false;
      }
      return true;
    });
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      const findObj = defaults.find(adDefault => (adDefault.id === obj.id));
      if (findObj === undefined)
        return true;
      return (obj.id !== findObj.id);
    });
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      const findObj = normals.find(adNormal => (adNormal.id === obj.id));
      if (findObj === undefined)
        return true;
      return (obj.id !== findObj.id);
    });
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      const findObj = adDefaults.find(adDefault => (adDefault.id === obj.id));
      if (findObj === undefined)
        return true;
      return (obj.id !== findObj.id);
    });
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      const findObj = adNormals.find(adNormal => (adNormal.id === obj.id));
      if (findObj === undefined)
        return true;
      return (obj.id !== findObj.id);
    });
    //console.log(newCampaignAdvertises);
    newCampaignAdvertises = newCampaignAdvertises.filter((obj) => {
      const findObj = adFrees.find(adFree => (adFree.id === obj.id));
      if (findObj === undefined)
        return true;
      return (obj.id !== findObj.id);
    });
    //console.log(newCampaignAdvertises);
    setCampaignAdvertises(newCampaignAdvertises);
    setSelectedAdvertises([]);

  }, [advertises]); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log("componentDidMount");

    if (!IsNoU(editCampaign)) {

      setCampaignName(editCampaign.name);
      setDisabledCampaignName(true);

      if (!IsNoU(editCampaign.lcd_off_start_time)) {
        setlcdOffStartTime(editCampaign.lcd_off_start_time);
      }
      if (!IsNoU(editCampaign.lcd_off_end_time)) {
        setlcdOffEndTime(editCampaign.lcd_off_end_time);
      }

      if (!IsNoU(editCampaign.volume)) {
        setDeviceVolume(editCampaign.volume);
      }
      if (!IsNoU(editCampaign.time_volume)) {
        setDeviceTimeVolume(editCampaign.time_volume);
      }
      if (!IsNoU(editCampaign.time_volume_start)) {
        setTimeVolumeStartTime(editCampaign.time_volume_start);
      }
      if (!IsNoU(editCampaign.time_volume_end)) {
        setTimeVolumeEndTime(editCampaign.time_volume_end);
      }

      if (!IsNoU(editCampaign.brightness)) {
        setDeviceBright(editCampaign.brightness);
      }
      if (!IsNoU(editCampaign.time_brightness)) {
        setDeviceTimeBright(editCampaign.time_brightness);
      }
      if (!IsNoU(editCampaign.time_brightness_start)) {
        setTimeBrightnessStartTime(editCampaign.time_brightness_start);
      }
      if (!IsNoU(editCampaign.time_brightness_end)) {
        setTimeBrightnessEndTime(editCampaign.time_brightness_end);
      }


      if (!IsNoU(editCampaign.area)) {
        setSelectedArea(editCampaign.area);

        let newAreaGroups = groups.filter(group => group.area === editCampaign.area);
        //console.log('new groups ->');
        //console.log(newAreaGroups);
        setAreaGroups(newAreaGroups);
        if (!IsNoU(editCampaign.group)) {
          setSelectedGroup(editCampaign.group);
        }
      }
      // if (!IsNoU(editCampaign.group)) {
      //   setSelectedGroup(editCampaign.group);
      // }

      if (modeReserveDialog) {
        if (IsNoU(editCampaign.reserved_at)){
          setSelectedDate(new Date());
          setSelectedTime('00:00');
        }
        else {
          setSelectedDate(moment(editCampaign.reserved_at).format('YYYY-MM-DD hh:mm'));
          setSelectedTime(moment(editCampaign.reserved_at).format('hh:mm'));
        }
      }

      if (!IsNoU(editCampaign.defaults)) {
        setDefaults(editCampaign.defaults);
        //console.log(editCampaign.defaults);
      }
      if (!IsNoU(editCampaign.normals)) {
        setNormals(editCampaign.normals);
        //console.log(editCampaign.normals);
      }
      if (!IsNoU(editCampaign.images)) {
        setImages(editCampaign.images);
        //console.log(editCampaign.normals);
      }
    }
    else {
      setCampaignName('');
      setDisabledCampaignName(false);

      setlcdOffStartTime('00:00');
      setlcdOffEndTime('00:00');

      setDeviceVolume(3);
      setDeviceTimeVolume(-1);
      setTimeVolumeStartTime('00:00');
      setTimeVolumeEndTime('00:00');

      setDeviceBright(3);
      setDeviceTimeBright(-1);
      setTimeBrightnessStartTime('00:00');
      setTimeBrightnessEndTime('00:00');

      setSelectedArea('');
      setSelectedGroup('');

      setTabIndex(0);

      setSelectedArea('');
      setSelectedGroup('');

      setDefaults([]);
      setNormals([]);
      setImages([]);

      setSelectedDate(new Date());
      setSelectedTime('00:00'); 
    }

  }, [editCampaign]); // empty-array means don't watch for any updates

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              {modeReserveDialog ? 
                modeRegisterDialog ? '예약배포 지정' : '예약배포 수정'
              :
                modeRegisterDialog ? '캠패인 등록' : '캠패인 수정'
              }
            </Typography>
            <Button autoFocus color="inherit" onClick={() => {

                if (IsNoU(campaignName) || campaignName.length <= 0) {
                  //console.log(campaignName);
                  toast("캠패인 명을 입력하세요.");
                  return ;
                }

                if (IsNoU(selectedArea) || selectedArea.length <= 0) {
                  //console.log(campaignName);
                  toast("권역을 선택하세요.");
                  return ;
                }

                // if (IsNoU(defaults) || defaults.length <= 0 &&
                //     IsNoU(normals) || normals.length <= 0) {
                //   //console.log(campaignName);
                //   toast("하나 이상의 광고를 선택하세요.");
                //   return ;
                // }

                if (modeReserveDialog) {
                  const today = new Date();
                  if ((moment(today).isAfter(selectedDate, 'year') ||
                      moment(today).isAfter(selectedDate, 'month') ||
                      moment(today).isAfter(selectedDate, 'day')) || 
                      (moment(today).isSame(selectedDate, 'day'))) {
                    toast("시작 날짜를 금일 이후로 선택하세요.");
                    return ;
                  }
                  else 
                  {
                    // if (moment(selectedStartDate).isSame(selectedEndDate, 'day')) {

                    // }
                    // else 
                    // if ((moment(selectedStartDate).isAfter(selectedEndDate, 'year') ||
                    //   moment(selectedStartDate).isAfter(selectedEndDate, 'month') ||
                    //   moment(selectedStartDate).isAfter(selectedEndDate, 'day'))) {
                    //   toast("종료 날짜를 시작일 이후로 선택하세요.");
                    //   return ;
                    // }
                  }
                }

                if (!IsNoU(editCampaign)) {
                  handleSaveCampaign();
                }
                else {
                  setOpenProgress(true);
                  handleCheckCampaign(campaignName);
                }

              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        <List>
          {/* <Box p={1}> */}
            <Typography
              className={classes.sub_header_title}
              color="textSecondary"
              //gutterBottom
            >
              *표시는 필수 항목
            </Typography>
          {/* </Box> */}
          
          <ListItem>
            <TextField 
              className={classes.registerListItemInput}
              id="outlined-basic-reg-campaign-name"
              label={'캠패인 명*'}
              //variant="outlined" 
              placeholder="캠패인 명을 입력하세요..."
              value={campaignName}
              onChange={event=> setCampaignName(event.target.value)}
              disabled={disabledCampaignName}
              margin="dense"/>

          </ListItem>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              화면강제 OFF 시간설정*
            </Typography>
            <TimeField
              value={lcdOffStartTime}
              onChange={onTimeChange('startTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={lcdOffStartTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
            <Box p={1}></Box>
            ~
            <Box p={1}></Box>
            <TimeField
              value={lcdOffEndTime}
              onChange={onTimeChange('endTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={lcdOffEndTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 기본볼륨*
            </Typography>
            <TextField
              className={classes.registerListItemVolume}
              id="outlined-select-device-volume"
              label="디바이스 볼륨"
              select
              value={deviceVolume}
              onChange={e => setDeviceVolume(e.target.value)}
              //variant="outlined"
              margin="dense"
            >
              {selectDeviceVolumes.map(obj => (
                <MenuItem key={obj.value} value={obj.value}>
                  {obj.label}
                </MenuItem>
              ))}
            </TextField>

            <Box p={2}></Box>

            <Typography
              className={classes.registerListItemSubTitle}
              color="textSecondary"
              gutterBottom
            >
              시간설정 볼륨
            </Typography>

            <TextField
              className={classes.registerListItemVolume}
              id="outlined-select-device-brightness"
              label="볼륨"
              select
              value={deviceTimeVolume}
              onChange={e => setDeviceTimeVolume(e.target.value)}
              //variant="outlined"
              margin="dense"
            >
              {selectDeviceVolumes.map(obj => (
                <MenuItem key={obj.value} value={obj.value}>
                  {obj.label}
                </MenuItem>
              ))}
            </TextField>
            <Box p={1}></Box>
            <TimeField
              value={timeVolumeStartTime}
              onChange={onTimeChange('timeVolumeStartTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={timeVolumeStartTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
            <Box p={1}></Box>
            ~
            <Box p={1}></Box>
            <TimeField
              value={timeVolumeEndTime}
              onChange={onTimeChange('timeVolumeEndTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={timeVolumeEndTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 기본밝기*
            </Typography>
            <TextField
              className={classes.registerListItemVolume}
              id="outlined-select-device-volume"
              label="디바이스 볼륨"
              select
              value={deviceBright}
              onChange={e => setDeviceBright(e.target.value)}
              //variant="outlined"
              margin="dense"
            >
              {selectDeviceVolumes.map(obj => (
                <MenuItem key={obj.value} value={obj.value}>
                  {obj.label}
                </MenuItem>
              ))}
            </TextField>

            <Box p={2}></Box>

            <Typography
              className={classes.registerListItemSubTitle}
              color="textSecondary"
              gutterBottom
            >
              시간설정 밝기
            </Typography>

            <TextField
              className={classes.registerListItemVolume}
              id="outlined-select-device-brightness"
              label="밝기"
              select
              value={deviceTimeBright}
              onChange={e => setDeviceTimeBright(e.target.value)}
              //variant="outlined"
              margin="dense"
            >
              {selectDeviceVolumes.map(obj => (
                <MenuItem key={obj.value} value={obj.value}>
                  {obj.label}
                </MenuItem>
              ))}
            </TextField>
            <Box p={1}></Box>
            <TimeField
              value={timeBrightnessStartTime}
              onChange={onTimeChange('timeBrightnessStartTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={timeBrightnessStartTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
            <Box p={1}></Box>
            ~
            <Box p={1}></Box>
            <TimeField
              value={timeBrightnessEndTime}
              onChange={onTimeChange('timeBrightnessEndTime')}
              style={{width: 88}}
              input={
                <TextField 
                  value={timeBrightnessEndTime} 
                  //variant="outlined" 
                  margin="dense"/>
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <SelectAreaGroup 
              areas={areas}
              groups={areaGroups}
              valueArea={selectedArea}
              onChangeArea={handleChangeArea}
              valueGroup={selectedGroup}
              onSetValueGroup={(group) => setSelectedGroup(group)}
              onChangeGroup={e => setSelectedGroup(e.target.value)}
            />
          </ListItem>
          <Divider />
          {modeReserveDialog &&
            (
              <div>
                <ListItem>
                  <Typography
                    className={classes.registerListItemTitle}
                    color="textSecondary"
                    gutterBottom
                  >
                    예약 배포 일시
                  </Typography>
                </ListItem>
                <ListItem>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy-MM-dd "
                    margin="dense"
                    id="date-picker-inline"
                    value={selectedDate}
                    onChange={date => setSelectedDate(date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />

                  {/* <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    margin="dense"
                    value={selectedTime}
                    onChange={date => setSelectedTime(date)}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                    }}
                  /> */}

                  </MuiPickersUtilsProvider>
                  <Box p={2}></Box>
                  <TimeField
                    value={selectedTime}
                    onChange={onTimeChange('selectedTime')}
                    style={{width: 88}}
                    input={
                      <TextField 
                        value={selectedTime} 
                        //variant="outlined" 
                        margin="dense"/>
                    }
                  />


                  <Box p={4}></Box>
                  <Typography
                    //className={classes.registerListItemSubTitle}
                    color="textSecondary"
                    gutterBottom
                  >
                    등록
                  </Typography>
                  <Box p={2}></Box>
                  <TextField 
                    className={classes.registerListItemInput}
                    id="outlined-basic-reg-campaign-name"
                    //variant="outlined" 
                    value={!IsNoU(editCampaign) && !IsNoU(editCampaign.deployed_at) ? moment(editCampaign.deployed_at).format('YYYY-MM-DD hh:mm') : ''}
                    disabled
                    margin="dense"/>
                </ListItem>
                <Divider />
              </div>
            )
          }
          <ListItem>
            <div>
              {/* {console.log(defaults)} */}
              <DragDropContext onDragEnd={onDragEnd}>
                디폴트 광고
                <div style={styleTabPanel}></div>
                  <Droppable droppableId="droppableDefault" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}>
                            {defaults.map((item, index) => (
                                <Draggable
                                    key={item.id}
                                    draggableId={String(item.id)}
                                    index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={
                                              getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style)
                                            }>
                                              {/* {console.log(item.template)} */}
                                            <StatusAdvertise 
                                              //color={'success'}
                                              color={adCheckStatus(item)}
                                            />
                                            {

                                            }
                                            <div 
                                              style={
                                                //getTexttyle(item.template === 'default' ? defaultColor : topColor, item.playtime)
                                                getTexttyle(item.template === 'default' ? defaultColor : topColor, getItemText(item).length)
                                              }
                                            >
                                              {getItemText(item)}
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                      )}
                  </Droppable>
                  <div style={styleTabPanel}></div>
                  일반/프리 광고
                  <div style={styleTabPanel}></div>
                  <Droppable droppableId="droppableNormal" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {normals.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={
                                                getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps.style)
                                              }>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={
                                                //getTexttyle(item.template === 'normal' ? normalColor : freeColor, item.playtime)
                                                getTexttyle(item.template === 'normal' ? normalColor : freeColor, getItemText(item).length)
                                              }
                                            >
                                                {getItemText(item)}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                  </Droppable>
                  <div style={styleTabPanel}></div>
                  이미지 광고
                  <div style={styleTabPanel}></div>
                  <Droppable droppableId="droppableImage" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {images.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={
                                                getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps.style)
                                              }>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={getImageTexttyle(imageColor, item.name.length)}>
                                                {item.name}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                  </Droppable>
                  <div style={styleTabPanel}></div>
                  <Tabs 
                    value={tabIndex} 
                    onChange={handleChangeTabs} 
                    aria-label="simple tabs example">
                    <Tab label="디폴트" {...a11yProps(0)} />
                    <Tab label="일반" {...a11yProps(1)} />
                    <Tab label="프리" {...a11yProps(2)} />
                    <Tab label="이미지" {...a11yProps(3)} />
                    <Tab label="탑" {...a11yProps(4)} />
                  </Tabs>
                  <div style={styleTabPanel}></div>
                  <div className={classes.row}>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={ onClickOpenInsertDialog }
                    >
                      추가
                    </Button>
                    <div className={classes.row_valued_advertise}>

                      <Typography
                        className={classes.status}
                        color="textSecondary"
                        gutterBottom
                      >
                        기간현황
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'success'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        유효
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'primary'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        예약
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'danger'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        종료
                      </Typography>
                    </div>
                    <div className={classes.row_type_advertise}>

                      <Typography
                        className={classes.status}
                        color="textSecondary"
                        gutterBottom
                      >
                        템플릿 현황
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'default'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        디폴트
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'normal'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        일반
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'free'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        프리
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'image'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        이미지
                      </Typography>

                      <StatusBullet
                        className={classes.status}
                        color={'top'}
                        size="md"
                      />

                      <Typography
                        //className={classes.root}
                        color="textSecondary"
                        gutterBottom
                      >
                        탑
                      </Typography>
                    </div>
                  </div>
                  <div style={styleTabPanel}></div>
                  <div hidden={tabIndex !== 0}>
                    <Droppable 
                      droppableId="droppableAdDefault" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {adDefaults.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps
                                                      .style
                                              )}>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={getTexttyle(defaultColor, getItemText(item).length)}>
                                                {getItemText(item)}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </div>
                  <div hidden={tabIndex !== 1}>
                  <Droppable 
                    hidden={tabIndex !== 0}
                    droppableId="droppableAdNormal" direction="horizontal">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}>
                            {adNormals.map((item, index) => (
                                <Draggable
                                    key={item.id}
                                    draggableId={String(item.id)}
                                    index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps
                                                    .style
                                            )}>
                                            <StatusAdvertise 
                                              color={adCheckStatus(item)}
                                            />
                                            <div style={getTexttyle(normalColor, getItemText(item).length)}>
                                              {getItemText(item)}
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                  </Droppable>
                  </div>
                  <div hidden={tabIndex !== 2}>
                    <Droppable 
                      hidden={tabIndex !== 0}
                      droppableId="droppableAdFree" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {adFrees.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps
                                                      .style
                                              )}>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={getTexttyle(freeColor, getItemText(item).length)}>
                                                {getItemText(item)}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </div>
                  <div hidden={tabIndex !== 3}>
                    <Droppable 
                      hidden={tabIndex !== 0}
                      droppableId="droppableAdImage" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {adImages.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps
                                                      .style
                                              )}>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={getImageTexttyle(imageColor, item.name.length)}>
                                                {item.name}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </div>
                  <div hidden={tabIndex !== 4}>
                    <Droppable 
                      hidden={tabIndex !== 0}
                      droppableId="droppableAdTop" direction="horizontal">
                      {(provided, snapshot) => (
                          <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                              {adTops.map((item, index) => (
                                  <Draggable
                                      key={item.id}
                                      draggableId={String(item.id)}
                                      index={index}>
                                      {(provided, snapshot) => (
                                          <div
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={getItemStyle(
                                                  snapshot.isDragging,
                                                  provided.draggableProps
                                                      .style
                                              )}>
                                              <StatusAdvertise 
                                                color={adCheckStatus(item)}
                                              />
                                              <div style={getTexttyle(topColor, getItemText(item).length)}>
                                                {getItemText(item)}
                                              </div>
                                          </div>
                                      )}
                                  </Draggable>
                              ))}
                              {provided.placeholder}
                          </div>
                      )}
                    </Droppable>
                  </div>
              </DragDropContext>

            </div>
          </ListItem>
          <Divider />
        </List>

        <Backdrop className={classes.backdrop} open={openProgress} /*onClick={() => setOpenProgress(false)}*/>
          <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>


      <Dialog fullScreen open={openInsertDialog} onClose={onClickCloseInsertDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseInsertDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              {tabIndex === 0 ? '디폴트' : 
              tabIndex === 1 ? '일반' :
              tabIndex === 2 ? '프리' :
              tabIndex === 3 ? '이미지' : 
              '탑'} 선택
            </Typography>
            <Button autoFocus color="inherit" onClick={() => {
                const selectedDatas = selectedAdvertises.map((selected)=>{
                  //console.log(selected);
                  return campaignAdvertises.find(advertise => (advertise.id === selected));
                });
                if (tabIndex === 0) {
                  //console.log(selectedDatas);
                  setAdDefaults(selectedDatas);
                }
                else if (tabIndex === 1) {
                  //console.log(selectedDatas);
                  setAdNormals(selectedDatas);
                }
                else if (tabIndex === 2) {
                  //console.log(selectedDatas);
                  setAdFrees(selectedDatas);
                }
                else if (tabIndex === 3) {
                  //console.log(selectedDatas);
                  setAdImages(selectedDatas);
                }
                else if (tabIndex === 4) {
                  //console.log(selectedDatas);
                  setAdTops(selectedDatas);
                }
                setOpenInsertDialog(false);
              }}>
              선택
            </Button>
          </Toolbar>
        </AppBar>

        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={campaignAdvertises.length > 0 && selectedAdvertises.length === campaignAdvertises.length}
                      color="primary"
                      indeterminate={
                        selectedAdvertises.length > 0 &&
                        selectedAdvertises.length < campaignAdvertises.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>광고명</TableCell>
                  <TableCell>광고대행사</TableCell>
                  <TableCell>광고주</TableCell>
                  <TableCell>기간현황</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {campaignAdvertises.map((advertise, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={advertise.id}
                    selected={selectedAdvertises.indexOf(advertise.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedAdvertises.indexOf(advertise.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, advertise.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{advertise.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{advertise.agency}</TableCell>
                    <TableCell>{advertise.client}</TableCell>
                    <TableCell> 
                      <StatusBullet
                          className={classes.status}
                          //color={'success'}
                          color={adCheckStatus(advertise)}
                          size="md"
                        />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </Dialog>
    </div>
  );
}

//export default RegisterCampaign;

RegisterCampaign.defaultProps = {
  advertises: [],
};

const mapStateToProps = state => ({
  advertises: state.campaigns.advertiseList,
  //checks: state.templates.templateChecks
});

const mapDispatchToProps = dispatch => ({
  getCampaignAdvertises: (template) => {getCampaignAdvertises(template, dispatch)},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterCampaign);